import { useEffect, useState } from 'react'

import { SnackbarNames } from 'interfaces/snackbar'
import { useActiveSnackbar, useConfigActions, useSnackbarRevision } from 'store/config/selectors'
import SnackbarWrapper from './wrapper'

const messages: Partial<Record<SnackbarNames, string>> = {
  [SnackbarNames.FAVORITE_ADDED]: 'Added as favorite',
  [SnackbarNames.FAVORITE_REMOVED]: 'Removed as favorite',
  [SnackbarNames.FAVORITES_LIMIT]: 'Maximum of 8 favorites reached.',
}

const FavoriteSnackbar = () => {
  const activeSnackbar = useActiveSnackbar()
  const snackbarRevision = useSnackbarRevision()
  const { setActiveSnackbar } = useConfigActions()
  const [showSnackbar, setShowSnackbar] = useState(true)

  useEffect(() => {
    setShowSnackbar(true)
    const slideOutTimeout = setTimeout(() => setShowSnackbar(false), 1600)
    const removeTimeout = setTimeout(() => setActiveSnackbar(null), 1900)

    return () => {
      clearTimeout(slideOutTimeout)
      clearTimeout(removeTimeout)
    }
  }, [activeSnackbar, setActiveSnackbar, snackbarRevision])

  return (
    <SnackbarWrapper compact role="status" showSnackbar={showSnackbar}>
      <h5>{activeSnackbar ? messages[activeSnackbar] : ''}</h5>
    </SnackbarWrapper>
  )
}

export default FavoriteSnackbar
